import {Entity} from '../entity/core.base.entity';
import {Metadata} from '../entity/core.entity.metadata';
import {IPage} from './page.interface';

export class Page<TEntity extends Entity> implements IPage<TEntity> {
    public content: TEntity[];
    public metadata: Metadata;
    public page: number;
    public pageSize: number;
    public totalPages: number;
    public total: number;
}